import Vue from "vue";
import TenderMixOperator from "./TenderMixOperator.vue";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";

Vue.config.productionTip = false;
Vue.config.ignoredElements = ["wc-monitoramento-tender-truck"];

new Vue({
  vuetify,
  i18n,
  render: h => h(TenderMixOperator)
}).$mount("#app");
